import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'



// firebase init
const firebaseConfig = {
    apiKey: "AIzaSyAA4YmSdZJEFdjWedL9fKB0fwI2cUwKu5w",
    authDomain: "sorteocch2026.firebaseapp.com",
    projectId: "sorteocch2026",
    storageBucket: "sorteocch2026.firebasestorage.app",
    messagingSenderId: "849374908333",
    appId: "1:849374908333:web:5aa6134d2e369241a85b24"
};
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()

firebase.firestore().enablePersistence()
    .catch((err) => {
        if (err.code == 'failed-precondition') {
            // Multiple tabs open, persistence can only be enabledcua
            // in one tab at a a time.
            // ...
        } else if (err.code == 'unimplemented') {
            // The current browser does not support all of the
            // features required to enable persistence
            // ...
        }
    });
// Subsequent queries will use persistence, if it was enabled successfully

const auth = firebase.auth()
const storage = firebase.storage()
const functions = firebase.functions()

// collection references
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')
const ticketsCollection = db.collection('tickets')

// export utils/refs
export {
    db,
    auth,
    storage,
    functions,
    usersCollection,
    postsCollection,
    commentsCollection,
    likesCollection,
    ticketsCollection
}